
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import SEOHead from '../../components/seo/SEOHead';
import { Link } from 'react-router-dom';

export default function Store() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "紳士服のミッキー",
    "description": "栃木県足利市にある個性派メンズファッション専門店",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/store`,
    "telephone": "0284-41-8666",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "相生町1-2",
      "addressLocality": "足利市",
      "addressRegion": "栃木県",
      "postalCode": "326-0053",
      "addressCountry": "JP"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 36.3456789,
      "longitude": 139.4567890
    },
    "openingHours": "Mo-Su 09:30-18:00",
    "priceRange": "¥¥",
    "image": "https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/5ea2722684ff1e23c9534a8aab372d81.jfif",
    "hasMap": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3222.8234567890123!2d139.4567890123456!3d36.3456789012345",
    "amenityFeature": [
      {
        "@type": "LocationFeatureSpecification",
        "name": "駐車場",
        "value": "6台完備（無料）"
      }
    ]
  };

  const accessMethods = [
    {
      icon: 'ri-car-line',
      title: 'お車でお越しの場合',
      description: '国道50号線から近く、駐車場完備（6台）',
      details: ['足利ICから約15分', '無料駐車場あり']
    },
    {
      icon: 'ri-train-line',
      title: '電車でお越しの場合',
      description: 'JR両毛線足利駅から徒歩12分',
      details: ['足利駅南口から徒歩12分', 'タクシーで約5分']
    }
  ];

  const storeInfo = [
    { icon: 'ri-map-pin-line', label: '住所', value: '栃木県足利市相生町1-2' },
    { icon: 'ri-phone-line', label: '電話番号', value: '0284-41-8666' },
    { icon: 'ri-time-line', label: '営業時間', value: 'AM9時30分 ～ PM6時00分' },
    { icon: 'ri-calendar-line', label: '定休日', value: '年中無休' },
    { icon: 'ri-car-line', label: '駐車場', value: '6台完備（無料）' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50">
      <SEOHead
        title="店舗情報 - 紳士服のミッキー | 足利市相生町のメンズファッション専門店"
        description="紳士服のミッキーの店舗情報。栃木県足利市相生町1-2。営業時間：AM9時30分～PM6時00分、年中無休。無料駐車場6台完備。"
        keywords="紳士服のミッキー,店舗情報,足利市,相生町,営業時間,駐車場,アクセス"
        ogTitle="店舗情報 - 紳士服のミッキー"
        ogDescription="足利市相生町にある紳士服のミッキーの店舗情報。営業時間、アクセス方法、駐車場情報をご案内。"
        ogImage="https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/5ea2722684ff1e23c9534a8aab372d81.jfif"
        structuredData={structuredData}
      />
      <Header />
      
      {/* ヒーローセクション */}
      <section className="py-20 bg-gradient-to-r from-purple-600 via-pink-600 to-orange-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-6xl font-bold mb-6">
            店舗情報
          </h1>
          <p className="text-2xl max-w-3xl mx-auto">
            足利市相生町にある「紳士服のミッキー」へのアクセス方法や<br />
            営業時間などの詳細情報をご案内いたします。
          </p>
        </div>
      </section>

      {/* 店舗基本情報 */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold mb-6 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
              基本情報
            </h2>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {storeInfo.map((info, index) => (
                <div key={index} className="flex items-center p-6 bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
                  <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                    <i className={`${info.icon} text-2xl text-white`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">{info.label}</h3>
                    <p className="text-xl text-gray-700">{info.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 地図セクション */}
      <section className="py-20 bg-gradient-to-r from-purple-100 via-pink-100 to-orange-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold mb-6 bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent">
              アクセスマップ
            </h2>
            <p className="text-xl text-gray-600">
              国道50号線沿いでアクセス良好。駐車場も完備しております。
            </p>
          </div>
          
          <div className="max-w-6xl mx-auto">
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3222.8234567890123!2d139.4567890123456!3d36.3456789012345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601f0b0b0b0b0b0b%3A0x0!2z5qCq5pyo55yM6Laz5Yip5biC55u45oCn55S677yR4oiS77yS!5e0!3m2!1sja!2sjp!4v1234567890123&markers=color:red%7Clabel:M%7C36.3456789,139.4567890"
                width="100%"
                height="500"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="紳士服のミッキー 地図"
              ></iframe>
            </div>
            
            {/* 地図の説明 */}
            <div className="mt-8 bg-white rounded-2xl shadow-lg p-6">
              <p className="text-center text-gray-600 mb-4">
                栃木県足利市相生町1-2に位置しており、国道50号線からアクセスしやすい立地です。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* アクセス方法 */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold mb-6 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              アクセス方法
            </h2>
            <p className="text-xl text-gray-600">
              お車、電車でのアクセス方法をご案内いたします。
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {accessMethods.map((method, index) => (
              <div key={index} className="bg-gradient-to-br frompurple-50 to-pink-50 rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="text-center mb-6">
                  <div className="w-20 h-20 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${method.icon} text-3xl text-white`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">{method.title}</h3>
                  <p className="text-lg text-gray-600">{method.description}</p>
                </div>
                
                <ul className="space-y-3">
                  {method.details.map((detail, detailIndex) => (
                    <li key={detailIndex} className="flex items-center text-gray-700">
                      <div className="w-2 h-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mr-3 flex-shrink-0"></div>
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 店舗外観・内観 */}
      <section className="py-20 bg-gradient-to-r from-purple-100 via-pink-100 to-orange-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold mb-6 bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
              店舗の様子
            </h2>
            <p className="text-xl text-gray-600">
              ゆっくりとお買い物をお楽しみください。
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            <div className="relative group">
              <img 
                src="https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/5ea2722684ff1e23c9534a8aab372d81.jfif"
                alt="店舗外観"
                className="w-full h-80 object-cover object-top rounded-2xl shadow-xl group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-2xl"></div>
              <div className="absolute bottom-6 left-6 text-white">
                <h3 className="text-2xl font-bold mb-2">店舗外観</h3>
              </div>
            </div>
            
            <div className="relative group">
              <img 
                src="https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/04638a9c89ee225925b8ea2ec9028ebc.jfif"
                alt="店舗内観"
                className="w-full h-80 object-cover rounded-2xl shadow-xl group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-2xl"></div>
              <div className="absolute bottom-6 left-6 text-white">
                <h3 className="text-2xl font-bold mb-2">店舗内観</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTAセクション */}
      <section className="py-20 bg-gradient-to-r from-purple-600 via-pink-600 to-orange-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-5xl font-bold mb-6">
            ご来店をお待ちしております
          </h2>
          <p className="text-2xl mb-8 max-w-3xl mx-auto">
            個性的なファッションをお探しの方は、ぜひ一度お気軽にお越しください。<br />
            専門スタッフがあなたにぴったりの一着をご提案いたします。
          </p>
          <div className="flex justify-center">
            <Link 
              to="/contact"
              className="font-bold rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap border-2 border-white text-white hover:bg-white hover:text-purple-600 text-xl px-10 py-5 inline-flex items-center"
            >
              <i className="ri-mail-line mr-2"></i>
              問い合わせする
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
